import {
  FETCHING_HUB_STREAMS_REQUEST, FETCHING_HUB_STREAMS_SUCCEEDED, FETCHING_HUB_STREAMS_FAILED,
  FETCHING_STREAM_REQUEST, FETCHING_STREAM_SUCCEEDED, FETCHING_STREAM_FAILED,
  FETCHING_GROUP_REQUEST, FETCHING_GROUP_SUCCEEDED, FETCHING_GROUP_FAILED,
  INVALIDATE_STREAM, INVALIDATE_GROUP
}
  from 'constants/actionTypes.jsx';
  import _ from 'lodash'

const initialState = {
  loading: false,
  invalidated: true,
  items: [],
  stream: {},
  group: {}
}

const entityState = {
  loading: false,
  item: null
}

function hubReducer(state = initialState, action) {
  switch (action.type) {
    case FETCHING_HUB_STREAMS_REQUEST:

      return {
        ...state,
        loading: true,
        invalidated: true
      }

    case FETCHING_HUB_STREAMS_SUCCEEDED:
      const response = action.payload.response;

      return {
        ...state,
        loading: false,
        invalidated: false,
        items: response.sort((a, b) => {
          return a.name > b.name ? 1 : a.name < b.name ? -1 : 0;
        })
      }

    case FETCHING_HUB_STREAMS_FAILED:
      return {
        ...state,
        loading: false,
        invalidated: true
      }

    case FETCHING_STREAM_REQUEST:
      var id = action.payload.request.id;
      var stream = state.stream[id] || entityState;
      return {
        ...state,
        stream: {
          ...state.stream,
          [id]: {
            ...stream,
            loading: action.payload.page === 0 ? true: false,
            invalidated: true
          }
        }
      }

    case FETCHING_STREAM_SUCCEEDED:

      var id = action.payload.id;
      var stream = state.stream[id] || entityState;

      const responses = action.payload.response;
      var records = responses.records;

      var items = [];
      if(_.get(action,"payload.response.currentPage") === 0){
        items = _.get(action,"payload.response.records",[])
      }
      else{
        items = [...stream.item.children,..._.get(action,"payload.response.records",[])]
      }

      var sortedSections = items.filter((item) => {
        return item.entityType === 'section';
      }).sort((a, b) => {
        return new Date(a.createdDate) - new Date(b.createdDate);
      });

      var sortedGroup = items.filter((item) => {
        return item.entityType === 'group';
      })

      var sortedAsset = items.filter((item) => {
        return item.entityType === 'asset';
      })

      var sortedChildren = [...sortedSections, ...sortedGroup, ...sortedAsset];
      items = _.uniqBy(items, 'id');

      return {
        ...state,
        stream: {
          ...state.stream,
          [id]: {
            ...stream,
            loading: false,
            invalidated: false,
            item: {
              currentPage: _.get(action,"payload.response.currentPage"),
              totalPages: _.get(action,"payload.response.totalPages"),
              recordsPerPage: _.get(action,"payload.response.recordsPerPage"),
              totalRecordsCount: _.get(action,"payload.response.totalRecordsCount"),
              records:items,
              children: sortedChildren
            }
          }
        }
      }  

    case FETCHING_STREAM_FAILED:
      var id = action.payload.id;
      var stream = state.stream[id] || entityState;

      return {
        ...state,
        stream: {
          ...state.stream,
          [id]: {
            ...stream,
            loading: false,
            invalidated: false,
            item: null,
            errors: action.payload.error.errors
          }
        }
      }

    case FETCHING_GROUP_REQUEST:
      var id = action.payload.id;
      var group = state.group[id] || entityState;

      return {
        ...state,
        group: {
          ...state.group,
          [id]: {
            ...group,
            loading: true,
            invalidated: true
          }
        }
      }

    case FETCHING_GROUP_SUCCEEDED:
      var id = action.payload.id;
      var group = state.group[id] || entityState;

      var items = action.payload.response.children || [];

      var sortedSections = items.filter((item) => {
        return item.entityType === 'section';
      }).sort((a, b) => {
        return new Date(a.createdDate) - new Date(b.createdDate);
      });

      var sortedGroup = items.filter((item) => {
        return item.entityType === 'group';
      })

      var sortedAsset = items.filter((item) => {
        return item.entityType === 'asset';
      })

      var sortedChildren = [...sortedSections, ...sortedGroup, ...sortedAsset];

      return {
        ...state,
        group: {
          ...state.group,
          [id]: {
            ...group,
            loading: false,
            invalidated: false,
            item: {
              ...action.payload.response,
              children: sortedChildren
            }
          }
        }
      }

    case FETCHING_GROUP_FAILED:
      var id = action.payload.id;
      var group = state.group[id] || entityState;

      return {
        ...state,
        group: {
          ...state.group,
          [id]: {
            ...group,
            loading: false,
            invalidated: true
          }
        }
      }

    case INVALIDATE_STREAM:

      return {
        ...state,
        stream: {},
        group: {},
      }

    case INVALIDATE_GROUP:

      return {
        ...state,
        group: {},
      }

    default:
      return state;
  }
}

export { hubReducer };
